import React from "react";

const NotificationCard = ({children}) => {
  return (
    <div className="notification-card">
      {children}
    </div>
  );
};

export default NotificationCard;
